'use client';

import { faShare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import { Button } from '@/components/atoms';
import { ModalWrapper } from '@/components/organisms';

interface ResendInvitationFormProps {
	title: string;
	invitationCode?: string;
	onClose: () => void;
}

export const InviteOrResendCodeModal = ({ title, invitationCode, onClose }: ResendInvitationFormProps) => {
	return (
		<ModalWrapper title={title} onClose={onClose} className="z-50 !mx-10 max-w-[524px] !gap-0 !p-6">
			<div>
				<div className="my-[18px] flex items-center text-base font-bold leading-6 text-gray-800">
					<span>Current code:</span>
					<span className="ml-1 text-base font-bold leading-6 text-[#36F]">{invitationCode}</span>
				</div>

				<hr className="mb-6 h-px rounded-md bg-[#AB95EA]" />

				<span className="text-base font-medium leading-6 text-gray-900">Click Share the code to copy to clipboard and paste to share.</span>

				<Button
					onClick={() => {
						navigator.clipboard.writeText(invitationCode || '');
						toast.success('Code copied to clipboard.');
						onClose();
					}}
					type="submit"
					className="mt-[50px] h-12 w-full cursor-pointer text-base font-semibold leading-7 bg-orange-500 hover:bg-orange-700 text-white"
				>
					<FontAwesomeIcon icon={faShare} />
					<span className="ml-2">Share the code</span>
				</Button>
			</div>
		</ModalWrapper>
	);
};
